import { getFirestore } from 'firebase/firestore';
import { useFirebase } from '../providers/firebase-provider';

export function useFirestore() {
  const { app } = useFirebase();

  return app && getFirestore(app);
}
